module.exports = __webpack_public_path__ + "img/pasargad.246fea76.png";